<template>
  <b-overlay :show="loading">
    <div class="ml-2 mb-2 font-weight-bold">
      <b-link to="/blog"><b-icon icon="chevron-left"></b-icon>Dental Blog Posts</b-link>
    </div>

    <b-container fluid>
      <b-row align-h="center">
        <b-col cols="12" lg="8">

          <div class="mt-1 mb-3">
              <div class="d-block d-sm-none">
                <img src="@/art/blog_sm_portrait.png" alt="Viva Insider" class="img-fluid" />
              </div>
              <div class="d-none d-sm-block d-md-none">
                <img src="@/art/blog_lg_portrait.png" alt="Viva Insider" class="img-fluid" />
              </div>
              <div class="d-none d-md-block d-lg-none">
                <img src="@/art/blog_sm_landscape.png" alt="Viva Insider" class="img-fluid" />
              </div>
              <div class="d-none d-lg-block d-xl-none">
                <img src="@/art/blog_lg_portrait.png" alt="Viva Insider" class="img-fluid" />
              </div>
              <div class="d-none d-xl-block">
                <img src="@/art/blog_lg_landscape.png" alt="Viva Insider" class="img-fluid" />
              </div>
          </div>

          <b-alert v-if="error" show variant="danger" class="mt-2">
            {{errorMsg}}
            <!-- TBD error component. -->
          </b-alert>

            <!-- Show selected blog post. -->
            <div class="div-section-body" style="padding: 0 5px 5px 5px;">
                <div class="mt-2">
                    <b-row class="pb-2">
                        <b-col>
                            <div class="class-title">{{blogObj.title}}</div>
                            <div class="class-author">by {{blogObj.author}}</div>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="text-center">
                            <b-img fluid v-bind:src="blogObj.photo" />
                        </b-col>
                    </b-row>
                    <b-row v-if="blogObj.podcastId != 0" class="mt-2">
                        <b-col>
                            <b-card sub-title="This article is based on the DentalTalk podcast below:">
                                <b-card-text>
                                    <b-link :to="`/podcast/${blogObj.podcastShowHash}/${blogObj.podcastHash}`">
                                        <b-icon icon="caret-right-fill"></b-icon>{{blogObj.podcastTitle}}
                                    </b-link>
                                </b-card-text>
                            </b-card>
                        </b-col>
                    </b-row>
                    <b-row>
                        <!-- :inner-html.prop instead of v-html -->
                        <b-col class="mt-2 txt-class-blurb" :inner-html.prop="stripBlogad(this.blogObj.body)"></b-col>
                    </b-row>
                </div>

              <div v-if="posts.length !== 0" class="mt-1">
                <!-- <div class="mb-1 font-weight-bold">Recent Dental Blog Posts</div> -->
                <h5>Recent Dental Blog Posts</h5>
                <ul>
                  <li v-for="(row) in posts" v-bind:key="row.id"><b-link :to="`/blog-post/${row.id}`">{{row.title}}</b-link></li>
                </ul>
              </div>

            </div>

        </b-col>
      </b-row>
    </b-container>
  </b-overlay>
</template>

<script>
/* eslint-disable */
'use strict'

import service from "@/service/service";
import utils from "@/utils/utils";
import EventBus from '@/plugins/eventbus'

export default {
  name: "BlogPost",
  data() {
    return {
      debug: false,
      error: false,
      errorMsg: null,
      loading: true,
      msg: "Blog Post",
      studentData: {status: false},
      studentHash: this.$root.getToken(),
      blogObj: {title: null, author: null, photo: null, body: null, podcastId: 0},
      posts: []     // recent blog posts
    }
  },
  props: {
    // route set to use props mapped to url parameters
    blogId: {
      type: String,
      default: '0'
    },
    nolog: {
      type: String,
      default: null
    },
  },
  computed: { },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    stripBlogad(body) {
      try {
        let aout = body.replace('[blogad]', '')
        aout = aout.replace('\n\n', '\n')
        return aout
      }
      catch(e) {
        return body
      }
    }
  },
  created() {
    if (this.debug) console.log(`blogId: ${this.blogId}`)
    if (this.debug) console.log(`studentHash: ${this.studentHash}`)
    if (this.blogId) {
        this.loading = true

        // VP passes 'nolog' if ad view already recorded
        let blockLog = (this.nolog === 'nolog') ? 1 : 0;  // 1(true) block logging

        service
        .getBlogPost(this.blogId, this.studentHash, blockLog )
        .then(
            (res => {
            if (this.debug) console.log(res)
            if (res.status) {
                this.blogObj = res.blogObj
                if (this.debug) console.log(`title: ${this.blogObj.title}`)
                if (this.debug) console.log(`podcastId: ${this.blogObj.podcastId}`)

                if (res.data && res.data.length !== 0) {
                  this.posts = res.data   // array of {id,title objects}
                }
            }
            else {
                this.error = true
                this.errorMsg = "Server error. Try later."
            }
            }).bind(this)
        )
        .finally(e => {
            this.loading = false
            if (this.debug) console.log(`finally...`);
        })
        .catch(e => {
            this.error = true
            this.errorMsg = "Error accessing API."
            console.log(e)
        })
    }
    else {
        // flag error!
        this.error = true
        this.errorMsg = "Go back and select blog post."
    }
  },
  mounted () {
    if (this.debug) console.log('blogpost mounted')
  },
  beforeDestroy() {
    if (this.debug) console.log(`blogpost destroyed`)
    this.posts = []
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/BlogPost.vue